var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-title"},[_c('p',{class:`${_vm.tipography} mrg-bottom-0`},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"underline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }